<div class="offline">
	<div class="error-alert">
		<span class="alert alert-danger">No network!</span>
	</div>
	<div class="error-message">
		<span>The Internet is currently unavailable</span>
	</div>
	<div class="error-alert">
		<span class="alert alert-danger">Connect to the internet and try again.</span>
	</div>
</div>
